import * as React from 'react';
import {
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
  List,
  ListRowProps,
  Size
} from 'react-virtualized';
import { Guid } from 'types/guid';
import { LanguageCode } from 'types/tenants/language-code';
import { RowProps, ComponentProps } from './row/props';
import { Table } from 'semantic-ui-react';

import './styles.css';

export interface ConnectedProps {
  language: LanguageCode;
  clientTransactionIds: Guid[];
}

export interface ActionProps {
  setSelectedTransactionId: (id: Guid) => void;
}

export type Props = ConnectedProps & ActionProps;

export const operationGrid = (HeaderComponent: React.ComponentType, RowComponent: React.ComponentType<RowProps & ComponentProps>) => {

  return class extends React.Component<Props> {
    private virtualList = React.createRef<List>();
    private cache = new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 20
    });

    constructor(props: Props) {
      super(props);
    }

    componentDidMount() {
      this.cache.clearAll();
      this.computeRows();
    }

    componentWillReceiveProps(nextProps: Props) {
      if (nextProps.clientTransactionIds.length > this.props.clientTransactionIds.length) {
        // If is currently scanning, go to top, otherwise it will be very laggy
        this.scrollToTop();
      }

      if (!this.areItemsSameOrder(nextProps.clientTransactionIds)) {
        // Usually it's when we retry an item in the list
        this.scrollToTop();
        this.updateList();
      }
    }

    public render() {
      let rows: JSX.Element;
      if (this.props.clientTransactionIds.length > 0) {
        rows = (
          <AutoSizer
            onResize={this.computeRows}
            // Required for the unit tests
            defaultHeight={300}
            defaultWidth={100}
          >
            {
              ({ height, width }: Size) => <List
                ref={this.virtualList}
                className="operations-list ui table unstackable"
                height={height}
                rowCount={this.props.clientTransactionIds.length}
                deferredMeasurementCache={this.cache}
                rowHeight={this.cache.rowHeight}
                width={width}
                overscanCount={5}
                rowRenderer={this.renderRow}
              />}
          </AutoSizer>
        );
      } else {
        rows = (
          <div className="empty-operation-row" />
        );
      }

      return (
        <>
          <Table unstackable={true} className="operations-list-headers">
            <HeaderComponent />
          </Table>
          <div className="grid-window">
            {rows}
          </div>
        </>
      );
    }

    renderRow = ({ index, parent, key, style }: ListRowProps) => {
      const clientTransactionId = this.props.clientTransactionIds[index];
      return (
        <div style={style} key={key} className="operation-item-row">
          <CellMeasurer cache={this.cache} parent={parent} columnIndex={0} rowIndex={index}>
            <RowComponent clientTransactionId={clientTransactionId}
              onClick={() => this.props.setSelectedTransactionId(clientTransactionId)} />
          </CellMeasurer>
        </div >
      );
    }

    computeRows = () => {
      this.cache.clearAll();
      if (this.virtualList.current) {
        const list: List = this.virtualList.current as List;
        list.recomputeRowHeights();
      }
    }

    updateList = () => {
      if (this.virtualList.current) {
        const list: List = this.virtualList.current as List;
        list.forceUpdateGrid();
      }
    }

    scrollToTop = () => {
      if (this.virtualList.current) {
        const list: List = this.virtualList.current as List;
        list.scrollToRow(0);
      }
    }

    areItemsSameOrder = (nextClientTransactionIds: Guid[]) => {
      var i = this.props.clientTransactionIds.length;
      if (i !== nextClientTransactionIds.length) {
        return false;
      }
      while (i--) {
        if (this.props.clientTransactionIds[i] !== nextClientTransactionIds[i]) {
          return false;
        }
      }
      return true;
    }
  };
};


// WEBPACK FOOTER //
// ./src/components/operation-grid/rows/component.tsx